import { useEffect } from 'react';
import { setCustomHeaderComponentName } from 'src/store/slices/uiFlowSlice';
import { useAppDispatch } from 'src/store/baseHooks';

/**
 * Hook to register a custom component to be used in the header component while in item view
 *
 * Parameter componentName must be the exact name of the React component. (Case sensitive).
 * @param componentName string
 */
export const useRegisterCustomHeaderComponent = (componentName: string): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!componentName) return;

    dispatch(setCustomHeaderComponentName(componentName));

    return () => {
      dispatch(setCustomHeaderComponentName(''));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [componentName]);
};
